import { FC, useEffect, useState } from 'react'

import {
  Chart,
  LineElement,
  PointElement,
  LineController,
  CategoryScale,
  LinearScale,
  Filler,
  Tooltip
} from 'chart.js'
import { ChartProps } from '../../../models/analytics'

Chart.register(
  CategoryScale,
  LinearScale,
  LineController,
  PointElement,
  LineElement,
  Tooltip,
  Filler
)

const hoverColor = '#3A98AB'
const gridColor = '#E2E4F8'
const labelColor = '#9C9EB2'
const pointBackgroundColor = '#FFFFFF'

const LineChart: FC<ChartProps> = ({ social, name, chartData }) => {
  const [myChart, setMyChart] = useState<any>()

  useEffect(() => {
    const ctx = document.getElementById(`${name}_${social}`)!

    let width: number, height: number, gradient: any
    const getGradient = (ctx: any, chartArea: any) => {
      const chartWidth = chartArea.right - chartArea.left
      const chartHeight = chartArea.bottom - chartArea.top
      if (gradient === null || width !== chartWidth || height !== chartHeight) {
        // Create the gradient because this is either the first render
        // or the size of the chart has changed
        width = chartWidth
        height = chartHeight
        gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top)
        gradient.addColorStop(1, 'rgba(58, 152, 171, 0.1)')
        gradient.addColorStop(0, 'rgba(58, 152, 171, 0)')
      }

      return gradient
    }

    const { labels, data } = chartData

    const chart = new Chart(ctx as HTMLCanvasElement, {
      type: 'line',
      data: {
        labels: labels,
        datasets: [
          {
            data: data,
            backgroundColor: (context) => {
              const chart = context.chart
              const { ctx, chartArea } = chart

              if (!chartArea) {
                // This case happens on initial chart load
                return null
              }
              return getGradient(ctx, chartArea)
            },
            borderWidth: 2,
            borderColor: hoverColor,
            hoverBackgroundColor: hoverColor,
            pointBackgroundColor: hoverColor,
            pointRadius: 3,
            pointHoverBackgroundColor: pointBackgroundColor,
            pointHoverBorderWidth: 2,
            pointHoverRadius: 6,
            fill: true
          }
        ]
      },
      options: {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            yAlign: 'bottom',
            position: 'nearest',
            enabled: false,
            external: ({ chart, tooltip }) => {
              // Tooltip Element
              let tooltipEl = chart.canvas.parentNode!.querySelector('div')
              if (!tooltipEl) {
                tooltipEl = document.createElement('div')
                tooltipEl.className = 'tooltip'

                const tooltipWrp = document.createElement('div')
                tooltipWrp.className = 'tooltip-wrp'
                tooltipEl.appendChild(tooltipWrp)

                chart.canvas.parentNode!.appendChild(tooltipEl)
              }
              // Hide if no tooltip
              if (tooltip.opacity === 0) {
                tooltipEl.style.opacity = '0'
                return
              }
              const [{ raw: formattedValuePositive, label }] = tooltip.dataPoints
              const barValue = `${formattedValuePositive}`

              const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas

              // Display, position, and set styles for font

              const innerHtml = `
                <div class='tooltip_container'>
                  <div class='tooltip_container-main-title'>${barValue}</div>
                  <div class='tooltip_container-sub-title'>${label}</div>
                </div>
                <div class='tooltip_arrow_top'></div>
              `

              const tooltipWrp = tooltipEl.getElementsByClassName('tooltip-wrp')
              while (tooltipWrp[0].firstChild) {
                tooltipWrp[0].firstChild.remove()
              }

              tooltipWrp[0].innerHTML = innerHtml
              const { scrollTop } = document.querySelector('.analytics-wrapper')!
              tooltipEl.style.opacity = '1'
              tooltipEl.style.left = positionX + tooltip.caretX + 'px'
              tooltipEl.style.top = positionY + tooltip.caretY - scrollTop - 62 + 'px'
            }
          }
        },
        scales: {
          x: {
            display: true,
            grid: {
              display: false,
              drawBorder: false
            },
            ticks: {
              color: labelColor
            }
          },
          y: {
            position: 'left',
            offset: false,
            grid: {
              borderDash: [8, 8],
              color: gridColor,
              drawBorder: false
            },
            ticks: {
              color: labelColor,
              padding: 15
            }
          }
        }
      }
    })

    ctx.style.height = '230px'
    setMyChart(chart)
    return () => chart.destroy()
  }, [])

  useEffect(() => {
    if (myChart) {
      const { labels, data } = chartData
      myChart.data.labels = labels
      myChart.data.datasets[0].data = data
      myChart.update()
    }
  }, [chartData])

  return (
    <>
      <canvas
        id={`${name}_${social}`}
        style={{ position: 'relative', height: '20vh', width: '80vw' }}
      ></canvas>
    </>
  )
}

export default LineChart
